<div class="fw-bold bg-white p-3 rounded-5 mb-3 shadow">
  <div class="row mt-3">
    <div class="col-10">
      <div class="mb-3 d-flex justify-content-between">
        <h2 class="title-list">Customer's Plans</h2>
      </div>
    </div>
    <div class="col-2 text end">
      <div class="d-flex justify-content-end bd-highlight">
        <div *ngIf="permissionService.isAdmin" class="me-3">
          <button class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#configurationsModalCustomer"
            appTooltip="Alerts">
            <i class="bi bi-gear"></i>
          </button>
        </div>
        <div class="me-3">
          <button class="btn btn-secondary" (click)="exportToExcelListPlanDevices()">
            <i class="bi bi-file-earmark-excel"></i>
          </button>
        </div>
        <div class="me-3">
          <button class="btn btn-secondary" (click)="isFilteredByStatus ? clearFilter() : filterByStatus(2)">
            <i class="bi bi-archive"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon1">
          <i class="bi bi-search"></i>
        </span>
        <input type="text" class="form-control input-label" placeholder="Search" [(ngModel)]="textoBusqueda"
          (input)="onSearchChange()" />
      </div>
    </div>
  </div>
  <div class="row d-none d-md-block">
    <div class="col-12">
      <div class="table-responsive rounded-5">
        <table class="table table-striped mb-0">
          <caption class="d-none">
            List of customers and their details
          </caption>
          <thead class="head-table">
            <tr>
              <th class="px-4 py-3 align-middle">Plan</th>
              <th class="px-4 py-3 align-middle">Plan description</th>
              <th class="px-4 py-3 align-middle">Price</th>
              <th class="px-4 py-3 align-middle">Allowance MB</th>
              <th class="px-4 py-3 align-middle">Current usage MB</th>
              <th class="px-4 py-3 align-middle">Status</th>
              <th class="px-4 py-3 align-middle">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="
                let plan of plansCustomer
                  | search : textoBusqueda : camposBusqueda
                  | slice
                    : (paginationService.currentPage - 1) * 10
                    : paginationService.currentPage * 10
              ">
              <td class="px-4 py-3 align-middle" [style.opacity]="plan.status === 0 ? '0.6' : '1'" [ngStyle]="{
                  width: '300px',
                  'word-wrap': 'break-word',
                  'white-space': 'normal'
                }" title="{{ plan.planDescription }}">
                {{ plan.planDescription }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="plan.status === 0 ? '0.6' : '1'" [ngStyle]="{
                  width: '400px',
                  'word-wrap': 'break-word',
                  'white-space': 'normal'
                }" title="{{ plan.description }}">
                {{ plan.description }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="plan.status === 0 ? '0.6' : '1'" [ngStyle]="{
                  width: '200px',
                  'word-wrap': 'break-word',
                  'white-space': 'normal'
                }" title="{{ plan.price }}">
                {{ plan.price }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="plan.status === 0 ? '0.6' : '1'"
                title="{{ plan.allowance }}">
                {{ plan.allowance }}
              </td>
              <td class="px-4 py-3 align-middle" [style.opacity]="plan.status === 0 ? '0.6' : '1'"
                title="{{ plan.currentConsumtion }}">
                {{ plan.currentConsumtion }}
              </td>
              <td class="px-4 py-3 align-middle">
                <div *ngIf="plan.status === 0 || plan.status === 1" class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" [disabled]="!permissionService.isAdmin" [(ngModel)]="plan.status" id="flexSwitchCheckDefault"
                    [checked]="plan.status === 1" (change)="
                      toggleStatus($event, plan); setSelectedCustomer(plan)
                    " data-bs-toggle="modal" data-bs-target="#modalSwitch" />
                </div>
                <div *ngIf="plan.status === 2">
                  <span class="archived">Archived</span>
                </div>
              </td>
              <td class="px-4 py-3 align-middle">
                  <div class="d-flex gap-2">
                      <!-- Кнопка «Редактировать» с значком в виде карандаша в квадрате -->
                      <button *ngIf="plan.status !== 2 && permissionService.isAdmin" class="btn btn-info" data-bs-toggle="modal"
                              data-bs-target="#modalUpdatePlan" (click)="setUpdatePlan(plan)"
                              style="background-color: #d1e7dd; border: 3px solid #d1e7dd" appTooltip="Edit Plan">
                          <i class="bi bi-pencil-square" style="color: #146c43"></i>
                      </button>

                      <!-- Кнопка «Удалить» со значком «Архив» -->
                      <button *ngIf="plan.status !== 2 && permissionService.isAdmin" class="btn btn-danger" data-bs-toggle="modal"
                              data-bs-target="#modalArchive" (click)="setArchivedCustomerPlan(plan)"
                              style="background-color: #f8d7da; border: 3px solid #f8d7da" appTooltip="Archive Plan">
                          <i class="bi bi-archive" style="color: #b02a37"></i>
                      </button>

                      <!-- Кнопка «Восстановить» со значком «Архив» -->
                      <button *ngIf="plan.status === 2 && permissionService.isAdmin" class="btn btn-primary" data-bs-toggle="modal"
                              data-bs-target="#modalArchive" (click)="setArchivedCustomerPlan(plan)"
                              style="background-color: #7ab956; border: 3px solid #7ab956" appTooltip="Restore Plan">
                          <i class="bi bi-archive"></i>
                      </button>


                      <!-- Кнопка «Обновить план» -->
                      <button *ngIf="plan.status !== 2" class="btn btn-info" (click)="navigateToCustomerPlans(plan)"
                              style="background-color: #cff4fc; border: 3px solid #cff4fc" appTooltip="Devices Plan">
                          <i class="bi bi-bar-chart" style="color: #0aa2c0"></i>
                      </button>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Cards para mobile -->
  <div class="row d-md-none">
    <div class="col-12">
      <div *ngFor="
          let plan of plansCustomer
            | search : textoBusqueda : camposBusqueda
            | slice
              : (paginationService.currentPage - 1) *
                  paginationService.recordsPerPage
              : paginationService.currentPage * paginationService.recordsPerPage
        " class="card mb-3">
        <div class="card-body">
          <h5 class="card-title">{{ plan.planDescription }}</h5>
          <p class="card-text">
            <strong>Plan description:</strong> {{ plan.description }}<br />
            <strong>Price:</strong> {{ plan.price }}<br />
            <strong>Allowance MB:</strong> {{ plan.allowance }}<br />
            <strong>Current usage MB:</strong> {{ plan.currentConsumtion
            }}<br />
          </p>
          <div class="d-flex gap-2">
            <td class="px-4 py-3 align-middle">
              <div *ngIf="plan.status === 0 || plan.status === 1" class="form-check form-switch">
                <input class="form-check-input" type="checkbox" [(ngModel)]="plan.status" id="flexSwitchCheckDefault"
                  [checked]="plan.status === 1" (change)="
                    toggleStatus($event, plan); setSelectedCustomer(plan)
                  " data-bs-toggle="modal" data-bs-target="#modalSwitch" />
              </div>
              <div *ngIf="plan.status === 2">
                <span class="archived">Archived</span>
              </div>
            </td>
            <td class="px-4 py-3 align-middle">
                <div class="d-flex gap-2">
                    <!-- Botón update plan -->
                    <button *ngIf="plan.status !== 2" class="btn btn-info" data-bs-toggle="modal"
                            data-bs-target="#modalUpdatePlan" (click)="setUpdatePlan(plan)"
                            style="background-color: #d1e7dd; border: 3px solid #d1e7dd" appTooltip="Edit Plan">
                        <i class="bi bi-pencil-square" style="color: #146c43"></i>
                    </button>

                    <!-- Кнопка «Удалить» со значком «Архив» -->
                    <button *ngIf="plan.status !== 2" class="btn btn-danger" data-bs-toggle="modal"
                            data-bs-target="#modalArchive" (click)="setArchivedCustomerPlan(plan)"
                            style="background-color: #f8d7da; border: 3px solid #f8d7da" appTooltip="Archive Plan">
                        <i class="bi bi-archive" style="color: #b02a37"></i>
                    </button>

                    <!-- Кнопка «Восстановить» со значком «Архив» -->
                    <button *ngIf="plan.status === 2" class="btn btn-primary" data-bs-toggle="modal" 
                            data-bs-target="#modalArchive" (click)="setArchivedCustomerPlan(plan)" 
                            style="background-color: #7ab956; border: 3px solid #7ab956" appTooltip="Restore Plan">
                      <i class="bi bi-archive"></i>
                    </button>


                    <!-- Botón Editar con icono pencil-square -->
                    <button *ngIf="plan.status !== 2" class="btn btn-info" (click)="navigateToCustomerPlans(plan)"
                            style="background-color: #cff4fc; border: 3px solid #cff4fc" appTooltip="Devices Plan">
                        <i class="bi bi-bar-chart" style="color: #0aa2c0"></i>
                    </button>
                </div>
            </td>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <label>
        Showing
        {{
        (paginationService.currentPage - 1) *
        paginationService.recordsPerPage +
        1
        }}
        to
        {{
        paginationService.currentPage * paginationService.recordsPerPage < plansCustomer.length ?
          paginationService.currentPage * paginationService.recordsPerPage : plansCustomer.length }} out of {{
          plansCustomer.length }} entries </label>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 d-flex justify-content-center">
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item" [class.disabled]="paginationService.currentPage === 1">
              <a class="page-link" href="javascript:void(0)" tabindex="-1" aria-disabled="true"
                (click)="previousPage()">
                <i class="bi bi-chevron-left"></i>
              </a>
            </li>
            <ng-container *ngFor="let page of pages">
              <li class="page-item" [class.active]="page === paginationService.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
              </li>
            </ng-container>
            <li class="page-item" [class.disabled]="
                paginationService.currentPage === paginationService.totalPages
              ">
              <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
                <i class="bi bi-chevron-right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div class="modal fade" id="modalSwitch" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
            Customer Active/Inactive
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="updateUserPlanStatus(false)"></button>
        </div>
        <div class="modal-body">
          Are you sure you want to Activate/Deactivate this customer?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateUserPlanStatus(false)">
            Close
          </button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updateUserPlanStatus(true)">
            Yes, Activate/Desactivate
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="modalArchive" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
                Customer Plan {{isFilteredByStatus ? 'Restore' : 'Archive'}}
            </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="updateUserPlanStatus(false)"></button>
        </div>
        <div class="modal-body">
            Are you sure you want to {{isFilteredByStatus ? 'Restore' : 'Archive'}} this customer plan?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateUserPlanStatus(false)">
            Close
          </button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updateUserPlanStatus(true)">
              Yes, {{isFilteredByStatus ? 'Restore' : 'Archive'}}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="modalUpdatePlan" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
            Update Plan
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="updatePlan(false)"></button>
        </div>
        <div class="modal-body">
          <div class="fw-bold bg-white p-3 rounded-5">
            <!-- Primera fila -->
            <div class="row mt-3">
              <div class="col">
                <label for="information" class="labelInformation">{{
                  information
                  }}</label>
              </div>
            </div>

            <!-- Segunda fila -->
            <div class="row mt-3">
              <div class="col">
                <label for="state" class="input-label">List of plans<span class="required">*</span></label>
                <div class="dropdown">
                  <select class="form-select input-label" [(ngModel)]="planSelected" (change)="checkFields()"
                    [class.is-invalid]="planSelected == 0">
                    <option value="0">Select Value</option>
                    <option *ngFor="let option of plans" [value]="option.planID">
                      {{ option.planName }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    Plan is required
                  </div>
                </div>
              </div>

              <div class="col">
                <label for="discount">Discount $</label>
                <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="discount"
                  placeholder="$ 0.00" appValidateDecimals />
              </div>

              <div class="col">
                <label for="state" class="input-label"></label>
                <div class="dropdown">
                  <select class="form-select input-label" [(ngModel)]="typeDiscount" (change)="checkFields()">
                    <option value="">Select Value</option>
                    <option *ngFor="let option of listTipeDiscount" [value]="option.aValue">
                      {{ option.aDescription }}
                    </option>
                  </select>

                </div>
              </div>

              <div class="col">
                <label for="dateValidFrom">Valid From <span class="required">*</span></label>
                <input type="date" class="form-control input-label" (input)="checkFields()" [(ngModel)]="dateValidFrom"
                  (keydown)="false" (keypress)="false" (keyup)="false" id="dateValidFrom" name="dateValidFrom"
                  [class.is-invalid]="!dateValidFrom" />
                <div class="invalid-feedback">
                  Valid from is required
                </div>
              </div>

              <div class="col">
                <label for="dateValidUntil">Valid Until</label>
                <input type="date" class="form-control input-label" (input)="checkFields()" [(ngModel)]="dateValidUntil"
                  [min]="minDate()" id="dateValidUntil" name="dateValidUntil" />
              </div>

              <div class="col">
                <label for="description">Description</label>
                <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="description" />
              </div>
            </div>

            <!-- Cuarta fila -->
            <div class="row mt-3">
              <div class="col-4">
                <label for="prorationFinal">Proration by final date</label>
                <input type="text" class="form-control input-label" disabled [(ngModel)]="prorationFinal" />
              </div>
              <div class="col-2 mt-4">
                <input type="checkbox" class="checkbox" id="renovation" [(ngModel)]="renovationChecked"
                  (ngModelChange)="onRenovationChange()" />
                <label for="renovation" class="mx-2">Renewal</label>
              </div>
              <div class="col-2 mt-4">
                <input type="checkbox" class="checkbox" id="transfer" [(ngModel)]="transferChecked"
                  [disabled]="!renovationChecked" />
                <label for="transfer" class="mx-2">Transfer Data</label>
              </div>
            </div>
          </div>

          <!-- History Table -->
          <div class="row">
            <div class="row">
              <h5 class="modal-title mb-3" id="exampleModalLabel" style="font-weight: bold">
                History
              </h5>

            </div>
            <div class="row">
              <app-table-control [columns]="columns" [data]="userPlanHistoryData"></app-table-control>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updatePlan(false)">
            Close
          </button>
          <button class="btn btn-primary w-100 w-md-auto me-2" [disabled]="!isFiledsValid()"
            (click)="calculateProration()">
            Calculate Proration
          </button>
          <!-- <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updatePlan(true)"
          [disabled]="!fieldsCompleted">
          Yes, Update
        </button> -->
          <button type="button" class="btn btn-primary" (click)="openConfirmationModalUpdate()"
            [disabled]="!fieldsCompleted">
            Yes, Update
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Confirmation Update -->
  <div class="modal fade" id="confirmationUpdate" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
            Update plan
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="updatePlan(false)"></button>
        </div>
        <div class="modal-body">Are you sure you want to update this plan?</div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updatePlan(false)">
            Close
          </button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updatePlan(true)">
            Yes, Update
          </button>
        </div>
      </div>
    </div>
  </div>



  <div class="modal fade" id="configurationsModalCustomer" tabindex="-1" aria-labelledby="configurationsModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" style="margin-top: 0vh">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="configurationsModalLabel" style="font-weight: bold">
            Alerts
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="closeModal()"></button>
        </div>
        <!-- Hacer el contenido del modal desplazable -->
        <div class="modal-body" style="max-height: 60vh; overflow-y: auto;">
          <!-- Iterar sobre los planes del cliente -->
          <div *ngFor="let plan of this.plansCustomer; let i = index" class="mb-3">
            <div class="card">
              <div class="card-header text-left" style="font-weight: bold">
                <strong>{{ plan.planDescription }}</strong>
              </div>
              <div class="card-body">
                <!-- Título del plan y control de rango -->
                <label [for]="'rangeControl' + i" class="form-label">
                  Set the usage alert threshold percentage:
                </label>
                <input type="range" class="form-range" [id]="'rangeControl' + i" min="50" max="100"
                  [(ngModel)]="plan.alertSendPercentage" (input)="updateValue($event)" />
                <!-- Mostrar el valor seleccionado dinámicamente -->
                <p class="mt-2">
                  Alert threshold for <strong>{{ plan.planDescription }}</strong> set to: {{ plan.alertSendPercentage }}%
                </p>
                <div class="d-flex justify-content-between" >
                  <label  class="form-label">Send threshold usage alert</label>
                  <div class="form-check form-switch">
                    <input type="checkbox" class="form-check-input ng-pristine ng-valid ng-touched" [checked]="plan.sendThresholdConsumptionAlert" (change)="onToggleChange($event, plan)">
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()">
            Close
          </button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updatePlansPercentage()">
            Save changes
          </button>
        </div>
      </div>
    </div>
  </div>


</div>
